import { useState } from "react";
import { Box, Button, Link, TextField, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Icon from "../../../../Icon/Icon";
import { EGInput } from "../../../../MainComponents/Input/EGInput";
import { EGBasicSelect } from "../../../../MainComponents/Select/EGBasicSelect";
import { returnIsValid } from "../Main/useConstants";
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton";

// Item en la lista de acciones o politicas
export const EvaluationListItem = ({
  idx,
  id,
  questionLabel,
  item,
  handleChange,
  handleChangueDetails,
  handleDeleteFromList,
  errors,
  triedToSave,
  catalogueOptions = [],
}) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme()

  const [activeDetails, setActiveDetails] = useState(!!item.details);

  return (
    <>
      <Box display="grid" gridTemplateColumns="1fr 48px" >
        {id === "actions" || id === "policies" ? (
          <EGBasicSelect
            label={questionLabel}
            value={item.value ?? item.reason ?? ""}
            options={catalogueOptions}
            onChange={(e) => handleChange(id, idx, e.target.value)}
            required={true}
            isValid={returnIsValid(errors, triedToSave)}
            showSuccessValidation={triedToSave}
            showHelpText={false}
          />
        ) : (
          <EGInput
            label={questionLabel}
            value={item.value ?? item.reason ?? ""}
            onChange={(e) => handleChange(id, idx, e.target.value)}
            required={true}
            isValid={returnIsValid(errors, triedToSave)}
            showSuccessValidation={triedToSave}
            showHelpText={false}
          />
        )}
        <EGIconButton
          iconName="close_icon"
          iconColor="white"
          color="error"
          title={t("Cancelar")}
          placement="bottom"
          onClick={() => handleDeleteFromList(id, idx)}
          iconSize={24}
          sx={{ height: 24, width: 24, padding: 0, alignSelf: "center", justifySelf: "center" }}
        />
        {
          !activeDetails &&
          <Link
            onClick={() => setActiveDetails(true)}
            underline="hover"
            textAlign="end"
            marginTop="3px"
          >
            + {t("evaluation.add_details")}
          </Link>
        }
      </Box>
      {
        activeDetails && 
        <TextField
          label={t("evaluation.details")}
          value={item.details ?? ""}
          onChange={(e) => handleChangueDetails(id, idx, e.target.value)}
          multiline
          rows={4}
          className="w-100"
        />
      }
    </>
  )
}